//Custom components
import { NumericFormat as NumberFormat } from 'react-number-format';
import StatCard from '../../../UI/Card/StatCard';

const TotalProjectsWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total Projects' stat={<NumberFormat value={count} displayType='text' thousandSeparator={true} />} />;
};

export default TotalProjectsWidget;
